import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import { LocationType } from '../../validation';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataNumberRow from './EcommDataNumberRow';
import EcommDoubleBookingRows from './EcommDoubleBookingRows';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import { ecommTableNumericRows, ecommTableDropdownRows } from '../../constants/ecommDataTableRowLabelAndValueKey';
import { numberRowMap, dropdownRowMap } from '../../helpers/ecommTableHelpers';

class EcommDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accData: {
        ...props.accData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    this.saveChange(name, value, key);
  }

  saveChange = (name, value, key) => {
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      accData: {
        ...prevState.accData,
        [key]: {
          ...prevState.accData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { accData } = this.state;
      saveOne({
        date: accData[key].date,
        locationType: 'set',
        locationId: accData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(
      prevState => ({
        accData: {
          ...prevState.accData,
          [key]: {
            ...prevState.accData[key],
            [name]: projectName,
            isSpecialProject,
          }
        }
      }),
      () => {
        const { accData } = this.state;
        saveOne({
          date: accData[key].date,
          locationType: 'set',
          locationId: accData[key].locationId,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      });
  };

  handleDoubleStylistCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isDoubleStylist: checked };
    const { saveOne } = this.props;
    this.setState(
      prevState => ({
        accData: {
          ...prevState.accData,
          [key]: {
            ...prevState.accData[key],
            isDoubleStylist: checked
          }
        }
      }),
      () => {
        const { accData } = this.state;
        saveOne({
          date: accData[key].date,
          locationType: 'set',
          locationId: accData[key].locationId,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      });
  };

  getTabIndex = (column)=>{
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { accData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      specialProjectOptions,
      canEdit,
      locationType
    } = this.props;

    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="AccTitle"
            tableTitle={i18n.t('location:accTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(accData).map(element =>
                accData[element].accName)}
            />
            {ecommTableNumericRows.slice(0, 3).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accData))}
            {ecommTableNumericRows.slice(7, 11).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accData))}
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              key={i18n.t('location:percentage').toUpperCase()}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={accData}
              max={999.99}
              rowTitle={i18n.t('location:percentage').toUpperCase()}
              valueKey="percentage"
            />
            {ecommTableDropdownRows.slice(0, 2).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, accData))}
            <EcommDoubleBookingRows 
              locationType={locationType}
              saveChange={this.saveChange}
              canEdit={canEdit}
              studioData={accData}
              getTabIndex={this.getTabIndex}
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={accData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            {ecommTableNumericRows.slice(11, 14).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accData))}
            {ecommTableNumericRows.slice(17, 21).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accData))}
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={accData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataTable.propTypes = {
  accData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  locationType: LocationType.isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  saveOne: PropTypes.func.isRequired,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  startTabIndex: PropTypes.number
};

EcommDataTable.defaultProps = {
  startTabIndex: 300
}

export default EcommDataTable;
